import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

// language files
import en from '@/lang/translations/en.json';

export const i18n = new VueI18n({
    locale: lang || 'en', // set locale
    fallbackLocale: 'en',
    messages: { en } // set locale messages
});

export const LANGUAGES = [
    {
        code: 'en',
        name: i18n.t('english')
    },
    {
        code: 'de',
        name: i18n.t('german')
    },
    {
        code: 'fr',
        name: i18n.t('french')
    },
    {
        code: 'zh-cn',
        name: i18n.t('chinese')
    }
];

const loadedLanguages = ['en']; // our default language that is preloaded

let lang = 'en';

export function initLang() {
    try {
        lang = localStorage.getItem('language') || 'en';
    } catch (e) {
        console.info(e);
    }
    loadLanguageAsync(lang);
}

function setI18nLanguage(lang) {
    try {
        i18n.locale = lang;
        axios.defaults.headers.common['Accept-Language'] = lang;
        document.querySelector('html').setAttribute('lang', lang);
    } catch (e) {
        console.info(e);
    }
    return lang;
}

export function loadLanguageAsync(lang = 'en') {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang));
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang));
    }

    // If the language hasn't been loaded yet
    const fileName = lang === 'zh-cn' ? 'cn' : lang;
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/translations/${fileName}.json`).then(messages => {
        i18n.setLocaleMessage(lang, messages.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
    });
}
